import { render, staticRenderFns } from "./StudentSelector.vue?vue&type=template&id=22a9c922"
import script from "./StudentSelector.ts?vue&type=script&lang=ts&external"
export * from "./StudentSelector.ts?vue&type=script&lang=ts&external"
import style0 from "./StudentSelector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports